import { Check, X } from "lucide-react";
import { Segmented } from "./Segmented";

// Presenze — same controls/icons/colors/terms/behaviour as the Calendar module.
const ATT_OPTS = [
  { v: "unrecorded", label: "Non registrato", node: <span>—</span>, selCls: "bg-[#5F6B64] text-white" },
  { v: "present", label: "Presente", node: <Check className="h-4 w-4" />, selCls: "bg-[#2E7D5B] text-white" },
  { v: "absent", label: "Assente", node: <X className="h-4 w-4" />, selCls: "bg-[#B91C1C] text-white" },
];

export function AttendanceSegments({ status, onSelect, disabled, testId, size }) {
  return <Segmented options={ATT_OPTS} value={status || "unrecorded"} onSelect={onSelect} disabled={disabled} testId={testId} size={size} />;
}

// Attività — same visual family as Presenze, different semantics (todo/done/skipped). Direct choice
// Da fare | ✓ Fatto | × Saltato. Modifica/Elimina stay separate from status (in the row actions).
const ACT_OPTS = [
  { v: "todo", label: "Da fare", node: <span>—</span>, selCls: "bg-[#5F6B64] text-white" },
  { v: "done", label: "Fatto", node: <Check className="h-4 w-4" />, selCls: "bg-[#2E7D5B] text-white" },
  { v: "skipped", label: "Saltato", node: <X className="h-4 w-4" />, selCls: "bg-[#B45309] text-white" },
];

export function ActivityStatusSegments({ status, onSelect, disabled, testId, size }) {
  return <Segmented options={ACT_OPTS} value={status || "todo"} onSelect={onSelect} disabled={disabled} testId={testId} size={size} />;
}
